import { GoTriangleDown, GoTriangleUp } from 'react-icons/go';

interface SortIconsProps {
  sortDirection: 'asc' | 'desc' | false;
}

export const SortIcons = ({ sortDirection }: SortIconsProps) => {
  return (
    <div className="flex flex-col">
      <GoTriangleUp
        className={`-mb-1 text-sm ${
          sortDirection === 'asc'
            ? 'text-neutralText dark:text-neutralText-dark'
            : 'text-neutralText/30 dark:text-neutralText-dark/30'
        }`}
      />
      <GoTriangleDown
        className={`-mt-1 text-sm ${
          sortDirection === 'desc'
            ? 'text-neutralText dark:text-neutralText-dark'
            : 'text-neutralText/30 dark:text-neutralText-dark/30'
        }`}
      />
    </div>
  );
};
